import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';

import { AppRoutes } from './app.routes';
import { SharedModule } from './shared/shared.module';
import { RegisterUserComponent } from './components/register-user/register-user.component';
import { TrocarSenhaDialogComponent } from './components/usuario/trocar-senha-dialog/trocar-senha-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import localePt from '@angular/common/locales/pt';
import { PriceParametrosComponent } from './src/app/components/adm/price-parametros/price-parametros.component';
import { ModalAbaParceiroComponent } from './components/aba-parceiros/modal-estimativa/modal-aba-parceiro/modal-aba-parceiro.component';
import { EditarParceiroEstimativaDialogComponent } from './components/aba-parceiros/editar-parceiro-estimativa-dalog/editar-parceiro-estimativa.component';
import { customCurrencyMaskConfig } from './components/price/price.module';
import { NgxCurrencyModule } from 'ngx-currency';
import { EditarCustoAdicionalEstimativaDialogComponent } from './components/custo-adicional/editar-custo-adicional-estimativa-dialog/editar-custo-adicional-estimativa.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
registerLocaleData(localePt);

@NgModule({
  imports: [
    BrowserModule,
    AppRoutes,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot(),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
  ],
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    LoginComponent,
    RegisterUserComponent,
    TrocarSenhaDialogComponent,
    PriceParametrosComponent,
    ModalAbaParceiroComponent,
    EditarParceiroEstimativaDialogComponent,
    EditarCustoAdicionalEstimativaDialogComponent,
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    MatDatepickerModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
